import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import LogoutPage from '../logout-page/logout-page';
import MainPage from '../main-page/main-page';

import { AppRoute } from '../../constants';

import './app.scss';

const App = () => (
  <div className="app">
    <Router>
      <Switch>
        <Route path={AppRoute.LOGOUT_PAGE_ROUTE}>
          <LogoutPage />
        </Route>

        <Route path={AppRoute.MAIN_PAGE_ROUTE} exact>
          <MainPage />
        </Route>
      </Switch>

      <Redirect to={AppRoute.MAIN_PAGE_ROUTE} />
    </Router>
  </div>
);

export default App;
